module.exports = __webpack_public_path__ + "img/smsRoaming1.b56e95e9.png";